module.exports = {"230624100":"泰康镇","230624101":"胡吉吐莫镇","230624102":"烟筒屯镇","230624103":"他拉哈镇","230624104":"连环湖镇","230624200":"一心乡","230624201":"克尔台乡","230624203":"敖林西伯乡","230624204":"巴彦查干乡","230624205":"腰新乡","230624206":"江湾乡","230624500":"绿色草原牧场","230624501":"大山种羊场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230624.json
// module id = 682
// module chunks = 0